import type { ComponentPropsWithRef, ReactNode } from 'react'

export interface PageHeaderContainerProps extends Omit<
    ComponentPropsWithRef<'div'>,
    'title'
> {
    children?: ReactNode
}

function PageHeaderContainer({
    children,
    className = '',
    ...restProps
}: PageHeaderContainerProps) {
    return (
        <div
            {...restProps}
            className={className}
        >
            <div className="flex justify-between gap-1 mb-2 items-center">
                {children}
            </div>
        </div>
    )
}

function PageHeaderTitle({
    children,
    className = '',
    ...restProps
}: ComponentPropsWithRef<'div'>) {
    return (
        <div
            {...restProps}
            className={`text-lg font-semibold ${className}`.trim()}
        >
            {children}
        </div>
    )
}

function PageHeaderAction({
    children,
    className = '',
    ...restProps
}: ComponentPropsWithRef<'div'>) {
    return (
        <div
            {...restProps}
            className={className}
        >
            {children}
        </div>
    )
}

export const PageHeader = Object.assign(PageHeaderContainer, {
    Container: PageHeaderContainer,
    Title: PageHeaderTitle,
    Action: PageHeaderAction,
})
